<script>
import Dfes from '@/components/Dfes.vue'
export default {
  components: {
    Dfes
  }
}
</script>

<template>
  <Dfes
    document="cfes"
    descriptionDocument="CFe (s)"
  />
</template>

<style>

</style>
